const resetPassword = {
  title: "Reset Password",
  subtitle: "Enter your new password below.",
  form: {
    newPasswordLabel: "New Password",
    newPasswordPlaceholder: "Enter new password",
    strengthLabel: "Password Strength:",
    confirmPasswordLabel: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm new password",
    requirementsTitle: "Password Requirements:",
  },
  loading: "Loading...",
  resetting: "Resetting...",
  submit: "Reset Password",
  backToLogin: "Back to Login",
  errors: {
    passwordMismatch: "Passwords do not match",
    resetFailed: "Failed to reset password",
  },
};

export default resetPassword;
